import { useQuery } from '@tanstack/react-query';
import sportsApi from '../../utils/sportsApi';
import { VerbalExposuresResponse } from '../../types/api';
import { sortKeysAndStringify } from '../utils/broadcastsUtils';

interface VerbalMentionsQuery {
    page: number;
    pageSize: number;
    client: {
        id: number;
    };
    orderBy: string[];
    startDate: string;
    endDate: string;
    rightsholderIds?: number[];
    useRightsholderAttribution?: boolean;
}

const fetchBroadcastsVerbalMentions = async (
    query: VerbalMentionsQuery,
    isCsvExport = false,
): Promise<VerbalExposuresResponse> => {
    const response = await sportsApi
        .url('/media-uploads/broadcasts/verbal-mentions')
        .headers(isCsvExport ? { 'csv-export': 'true' } : {})
        .json({
            action: 'fetchQuery',
            domainObject: query,
        })
        .post()
        .json();

    return response as unknown as VerbalExposuresResponse;
};

const useBroadcastsVerbalMentions = (
    query: VerbalMentionsQuery,
    isCsvExport = false,
    enabled = true,
) => {
    return useQuery(
        ['BroadcastsVerbalMentionsKey', sortKeysAndStringify(query)],
        () => fetchBroadcastsVerbalMentions(query, isCsvExport),
        { enabled, initialData: { verbalExposures: [], total: 0 } },
    );
};

export default useBroadcastsVerbalMentions;
